<template>
  <div class="profile-hopping" :class="{ active, hidden }">
    <input-text v-model="topic"
                class="topic-input"
                type="text"
                spellcheck="false"
                :placeholder="$t('hopping')"
                :disabled="disabled"
                @focus="focusTopic"
                @blur="blurTopic"
    />
    <img class="pencil-icon" src="@/assets/images/profiles/hopping/ic_pencil.svg" alt="topic icon">

    <Button type="button" class="send-topic-btn p-button-link" @click="sendTopic">
      <img src="@/assets/images/profiles/hopping/ic_send.svg" alt="send icon">
    </Button>
  </div>
</template>

<script>
export default {
  name: "WhatsHoppingNew",
  components: {
  },
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      topic: this.value,
      active: false
    }
  },
  computed: {
    hidden() {
      return !this.topic && this.disabled;
    }
  },
  methods: {
    focusTopic() {
      this.active = true;
    },
    blurTopic() {
      this.active = false;
      this.sendTopic();
    },
    sendTopic() {
      this.$emit('send-topic', this.topic);
    }
  }
}
</script>

<style scoped lang="scss">

.profile-hopping {
  position: relative;
  height: 50px;
  width: 100%;
  border-radius: 4px;
  background-color: #c6f8cb;
  transition: .2s;
  &:before {
    content: "";
    position: absolute;
    height: 0;
    width: 0;
    top: 19px;
    left: -6px;
    border-width: 6px 6px 6px 0;
    border-style: solid;
    border-color: transparent #c6f8cb;
    -webkit-transition: .2s;
    transition: .2s;
  }
  &:hover {
    background-color: #abffb4;
  }
  .pencil-icon {
    position: absolute;
    left: 20px;
    top: 20px;
  }
  .send-topic-btn {
    position: absolute;
    right: 0;
    top: 7px;
    cursor: pointer;
    transition: .2s;
  }

  &.active {
    background-color: #fff;

    &:before {
      border-color: transparent #fff;
    }
  }

  .topic-input {
    height: 100%;
    width: 100%;
    padding: 0 45px 0 41px;
    background-color: transparent;

    border: none;
    font-weight: 400;
    font-size: 16px;
    color: #16ca55;
    transition: .2s;
  }
}

</style>
